import { Action, createReducer, on } from '@ngrx/store'
import {
  delete_entity_wise_data_action,
  load_dashboard_success,
  load_entity_wise_data_success
} from '../action/dashboard.action'
import {
  DashboardState,
  EntityWiseDataState,
  initialEntityWiseDataState,
  initialUserDashboardState
} from '../state/dashboard.state'

export function dashboardReducer(state: DashboardState, action: Action) {
  return _dashboardReducer(state, action)
}

const _dashboardReducer = createReducer(
  initialUserDashboardState,
  on(load_dashboard_success, (state, dashboardAPIData) => {
    return {
      ...state,
      statistics: dashboardAPIData.statistics,
      announcements: dashboardAPIData.announcements,
      calendarEvents: dashboardAPIData.calendarEvents,
      totalHeadCount: dashboardAPIData.totalHeadCount
    }
  })
)

export function entityWiseReducer(state: EntityWiseDataState, action: Action) {
  return _entityWiseReducer(state, action)
}

const _entityWiseReducer = createReducer(
  initialEntityWiseDataState,
  on(load_entity_wise_data_success, (state, apiData) => {
    return {
      ...state,
      statistics: apiData.statistics
    }
  }),
  on(delete_entity_wise_data_action, state => {
    return {
      ...state,
      statistics: null
    }
  })
)
